import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import AdminShell from '../../components/Survey/admin/AdminShell';
import { Actions as SURVEY_ACTIONS } from '../../store/actions/surveyActions';

const SurveyResults = ({ results, getCampaignResults }) => {
  const { id } = useParams();

  useEffect(() => {
    getCampaignResults(id);
  }, [id, getCampaignResults]);

  return (
    <AdminShell
      breadcrumbs={[
        { label: 'Surveys', to: '/surveys' },
        { label: 'Results' },
      ]}
      eyebrow='Survey results'
      title='Campaign results'>
      <Card>
        <CardHeader>
          <CardTitle>Survey results</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className='text-xs whitespace-pre-wrap bg-muted p-3 rounded-lg'>{JSON.stringify(results || {}, null, 2)}</pre>
        </CardContent>
      </Card>
    </AdminShell>
  );
};

const mapStateToProps = (state) => ({
  results: state.survey?.campaignResults,
});

const mapDispatchToProps = {
  getCampaignResults: SURVEY_ACTIONS.getCampaignResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyResults);
